import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

const MENU = [
  { id: 'dashboard', label: 'Дашборд', icon: '▦', type: 'item' },
  {
    id: 'agents', label: 'Агенты', icon: '⚡', type: 'group',
    children: [
      { id: 'agent-reports', label: 'Мониторинг отчётов', icon: '📋' },
      { id: 'agent-reconcile', label: 'Сверка TL/BK', icon: '🔄', disabled: true },
      { id: 'agent-pl', label: 'P&L анализ', icon: '📊', disabled: true },
      { id: 'agent-prices', label: 'Мониторинг цен', icon: '💰' },
    ]
  },
  { id: 'employees', label: 'Сотрудники', icon: '👥', type: 'item' },
  { id: 'schedule', label: 'Расписание', icon: '📅', type: 'item' },
  { id: 'payroll', label: 'Ведомости', icon: '💰', type: 'item' },
  { id: 'settings', label: 'Настройки', icon: '⚙️', type: 'item', disabled: true },
];

export default function Sidebar({ activePage, setActivePage, user }) {
  const { logout } = useAuth();
  const [openGroups, setOpenGroups] = useState({ agents: true });

  const toggleGroup = (id) => setOpenGroups(prev => ({ ...prev, [id]: !prev[id] }));

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <span className="logo-icon">⬡</span>
        <div>
          <div className="logo-title">THOTH AI</div>
          <div className="logo-sub">PLATFORM</div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {MENU.map(item => {
          if (item.type === 'item') {
            return (
              <button key={item.id}
                className={`nav-item ${activePage === item.id ? 'active' : ''} ${item.disabled ? 'disabled' : ''}`}
                onClick={() => !item.disabled && setActivePage(item.id)}>
                <span className="nav-icon">{item.icon}</span>
                <span>{item.label}</span>
              </button>
            );
          }
          if (item.type === 'group') {
            return (
              <div key={item.id} className="nav-group">
                <button className="nav-group-header" onClick={() => toggleGroup(item.id)}>
                  <span className="nav-icon">{item.icon}</span>
                  <span>{item.label}</span>
                  <span className={`nav-arrow ${openGroups[item.id] ? 'open' : ''}`}>›</span>
                </button>
                {openGroups[item.id] && (
                  <div className="nav-children">
                    {item.children.map(child => (
                      <button key={child.id}
                        className={`nav-child ${activePage === child.id ? 'active' : ''} ${child.disabled ? 'disabled' : ''}`}
                        onClick={() => !child.disabled && setActivePage(child.id)}>
                        <span className="nav-icon">{child.icon}</span>
                        <span>{child.label}</span>
                        {child.disabled && <span className="nav-soon">скоро</span>}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            );
          }
          return null;
        })}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">{user?.name?.[0] || 'S'}</div>
          <div className="user-details">
            <div className="user-name">{user?.name || 'Сергей'}</div>
            <div className="user-role">{user?.role === 'superadmin' ? 'Супер Админ' : 'Администратор'}</div>
          </div>
        </div>
        <button className="btn-logout" onClick={logout} title="Выйти">⏻</button>
      </div>
    </aside>
  );
}
